import { AutoOpenTrigger, QueueWithResources } from "@/repository/models";

export const openPopup = (
	url?: string,
	target: string = "",
	features: string = "height=700,width=900"
) => {
	if (!url) {
		console.warn("Popup url is required");
		return;
	}

	window.open(url, target, features);
};

export const openResourcesPopup = (
	queue: QueueWithResources | undefined,
	autoOpenTrigger: AutoOpenTrigger
) => {
	if (!queue || !queue?.resources) {
		return;
	}

	for (const resource of queue.resources) {
		if (resource.autoOpenTrigger === autoOpenTrigger) {
			openPopup(resource.url);
		}
	}
};
